import { IPermitTypeFieldDefaultOptions, SortDirection } from '~/client/graph'
import SortOrder from '~/client/src/shared/enums/SortOrder'
import { isResourceQuickFilterKey } from '~/client/src/shared/hooks/useResourceQuickFilters'

import { fromCompoundIds } from './filterCompoundIds'

export interface IParsedDefaults {
  sortKey?: string | null
  sortOrder?: SortOrder
  groupByKey?: string | null
  filterSelection?: Map<string, Set<string>>
}

export interface ILocalDefaults {
  sortKey: string | null
  sortOrder: SortOrder
  groupByKey: string | null
  filterSelection: string[]
}

export function areLocalDefaultsEqual(
  left: ILocalDefaults,
  right: ILocalDefaults,
): boolean {
  return (
    left.sortKey === right.sortKey &&
    left.sortOrder === right.sortOrder &&
    left.groupByKey === right.groupByKey &&
    left.filterSelection.length === right.filterSelection.length &&
    left.filterSelection.every(
      (value, index) => value === right.filterSelection[index],
    )
  )
}

export function parseDefaultOptions(
  options?: IPermitTypeFieldDefaultOptions | null,
): IParsedDefaults {
  if (!options) return {}

  const compoundIds = extractCompoundFilterIds(options)

  return {
    sortKey: options.sortOption || undefined,
    sortOrder:
      options.sortDirection === SortDirection.Descending
        ? SortOrder.DESC
        : options.sortDirection === SortDirection.Ascending
          ? SortOrder.ASC
          : undefined,
    groupByKey: options.groupOption || undefined,
    filterSelection: compoundIds.length
      ? fromCompoundIds(compoundIds)
      : undefined,
  }
}

export function parseDefaultOptionsFlat(
  options?: IPermitTypeFieldDefaultOptions | null,
): ILocalDefaults {
  return {
    sortKey: options?.sortOption ?? null,
    sortOrder:
      options?.sortDirection === SortDirection.Descending
        ? SortOrder.DESC
        : SortOrder.ASC,
    groupByKey: options?.groupOption ?? null,
    filterSelection: extractCompoundFilterIds(options),
  }
}

function extractCompoundFilterIds(
  options?: IPermitTypeFieldDefaultOptions | null,
): string[] {
  return (
    options?.filterOptions?.flatMap(fo => {
      if (
        !fo?.values?.length ||
        !fo.type ||
        isResourceQuickFilterKey(fo.type)
      ) {
        return []
      }
      return fo.values.filter(v => v != null).map(v => `${fo.type}:${v}`)
    }) ?? []
  )
}
